/**
 * DAM Labels module - common methods
 *
 * @author MattJS (matt@yext.com)
 */
goog.module('yext.dam.labels.view');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const {default: routes} = goog.require('yext.dam.routes');
/** @suppress {extraRequire} */
goog.require('yext.plugins.contextualHelp');

/** @type {!jQuery} */
let $contextContentTemplate = undefined;

/**
 * Builds HTML string for view label
 *
 * @param {string} name Name of label
 * @return {string} Html for the label view
 */
function buildViewLabelHtml(name) {
  return '<span class="badge-label asset-label-view">'+name+'</span>';
}

/**
 * Builds HTML string for interactive label for photos
 *
 * @param {!Object} asset Asset that corresponds to the photo
 * @param {boolean} showConstraintWarning boolean that determines if photo has a constraint warning
 * @return {!jQuery} jQuery with the contextual help already bound
 */
function getAssetViewLabel(asset, showConstraintWarning) {
  var damEnabled = !!$('.js-asset-selector').data('dam-enabled');
  if (damEnabled || showConstraintWarning) {
    if (!$contextContentTemplate) {
      $contextContentTemplate = $($('.js-photo-label-context-template').html());
    }

    if (!$contextContentTemplate.length) {
      return;
    }

    var $contextContent = $contextContentTemplate.clone();
    var $templateLabels = $contextContent.find('.js-asset-labels');
    var $labelView = $('<i class="listing-status-caution"></i>');

    var width = '150px';

    if (showConstraintWarning) {
      $labelView = $('<i class="gmb-constraint-warning"></i>');
      $contextContent.find('.js-photo-warning').show();
    } else if (damEnabled && asset && asset.id && asset.labels) {
      if (asset.labels.length === 1) {
        $labelView = $(buildViewLabelHtml(asset.labels[0].name));
      } else if (asset.labels.length > 1) {
        $labelView = $(buildViewLabelHtml(yext.msgn('1 label', '{0} labels', asset.labels.length)));
        for (var i = 0; i < asset.labels.length; i++) {
          $templateLabels.append($(buildViewLabelHtml(asset.labels[i].name)));
        }
        $templateLabels.show();
      }
      $contextContent.find('.js-asset-name').text(asset.name);
    }

    if (damEnabled && asset && asset.id) {
      $contextContent
        .find('.js-asset-link')
        .attr('href', routes.viewAsset() + '/' + asset.id)
        .show();
    }

    // Default tool tip options for the contextual help on the assets table page
    $labelView.contextualHelp({
      event: 'hover',
      interactive: true,
      customClass: 'flat-tooltip',
      fade: true,
      contentElement: $contextContent,
      width: width,
    });

    return $labelView;
  }
}

exports = {
  $contextContentTemplate,
  buildViewLabelHtml,
  getAssetViewLabel,
};
